import OrderShippingAddressModal from './OrderShippingAddressModal'

export default OrderShippingAddressModal

export { OrderShippingAddressForm } from './OrderShippingAddressModal'
